module.exports = __webpack_public_path__ + "img/Croatia.33fb769c.png";